module.exports = __webpack_public_path__ + "img/6-m.2e30033f.jpg";